import styled from "styled-components";

const Wrapper = styled.div`
  font-size: inherit;
  font-weight: inherit;
  display: inline-block;
  position: relative;
`;

const Shade = styled.div`
  width: 98%;
  height: 45%;
  position: absolute;
  bottom: 0;
  right: 1%;
  background-color: #ffba5c;
  z-index: 1;
`;

const TextWrapper = styled.div`
  position: relative;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
`;

const Text = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 2;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
`;

const TextShadeWrapper = ({ children }) => {
  return (
    <Wrapper>
      <TextWrapper>
        {children}
        <Text>{children}</Text>
      </TextWrapper>
      <Shade />
    </Wrapper>
  );
};

export default TextShadeWrapper;
